// extracted by mini-css-extract-plugin
export default {"container":"Transportation_container__PUkra","content":"Transportation_content__zcJCt","name":"Transportation_name__CkTxv","distance":"Transportation_distance__5NP9c"};